<template>
   <el-dialog custom-class="dialog-wrapper" :title="dialogTitle"  :close-on-click-modal="false" :modal-append-to-body="false"
      v-model="dialogVisible">

      <div class="item-title">屏蔽总开关</div>
      <el-form :inline="true">
         <div class="margin-bottom-10" v-for="(item, index) in switchList" :key="index">
            <el-form-item label="手机系统">
               <el-select v-model="item.type">
                  <el-option label="Android" value="0" :disabled="switchList.some((item) => item.type === '0')">
                  </el-option>
                  <el-option label="iOS" value="1" :disabled="switchList.some((item) => item.type === '1')">
                  </el-option>
                  <el-option label="HarmonyOS" value="2" :disabled="switchList.some((item) => item.type === '2')">
                  </el-option>
               </el-select>
            </el-form-item>
            <el-form-item label="是否屏蔽">
               <el-switch v-model="item.switch" on-text="" off-text=""></el-switch>
            </el-form-item>
            <el-button v-if="index == 0" type="primary" @click="clickAddSwitch">添加</el-button>
            <el-button v-if="index != 0" type="danger" icon="delete" @click="clickDeleteSwitch(index)"></el-button>
         </div>
      </el-form>

      <div class="item-title">手机型号屏蔽</div>
      <el-form :inline="true">
         <div class="margin-bottom-10" v-for="(item, index) in deviceList" :key="index">
            <el-form-item label="手机型号">
               <el-input v-model="item.type"></el-input>
            </el-form-item>
            <el-button v-if="index == 0" type="primary" @click="clickAddType">添加</el-button>
            <el-button v-if="index != 0" type="danger" icon="delete" @click="clickDeleteType(index)"></el-button>
         </div>
      </el-form>

      <div class="item-title">版本号屏蔽</div>
      <el-form :inline="true">
         <div class="margin-bottom-10" v-for="(item, index) in versionList" :key="index">
            <el-form-item label="手机系统">
               <el-select v-model="item.type">
                  <el-option label="Android" value="0"></el-option>
                  <el-option label="iOS" value="1"></el-option>
                  <el-option label="HarmonyOS" value="2"></el-option>
               </el-select>
            </el-form-item>
            <el-form-item label="版本号">
               <el-input v-model="item.version"></el-input>
            </el-form-item>
            <el-button v-if="index == 0" type="primary" @click="clickAddVersion">添加</el-button>
            <el-button v-if="index != 0" type="danger" icon="delete" @click="clickDeleteVersion(index)"></el-button>
         </div>
      </el-form>

      <template #footer>
         <div class="flex-row-center">
            <el-button @click="dialogVisible = false">取消</el-button>
            <el-button type="primary" @click="clickEditDone">确定</el-button>
         </div>
      </template>
   </el-dialog>
</template>

<script>
export default {
   props: {
      dialogTitle: '',
      dataSource: {}
   },

   data() {
      return {
         dialogVisible: false,
         switchList: [{ type: '', switch: false }],
         deviceList: [{ type: '' }],
         versionList: [{ type: '', version: '' }],
      }
   },

   methods: {
      // 发送更新
      sendUpdate() {
         let resValue = {};
         const switchValue = this.switchList.filter((item) => {
            return item.type && item.type !== '' && item.switch;
         }).map((item) => {
            return item.type + ':' + (item.switch ? '1' : '0');
         });
         if (switchValue.length) {
            resValue['all'] = switchValue;
         }

         const deviceValue = this.deviceList.filter((item) => {
            return item.type && item.type !== '';
         }).map((item) => {
            return item.type;
         });
         if (deviceValue.length) {
            resValue['device'] = deviceValue;
         }

         const versionValue = this.versionList.filter((item) => {
            return item.type && item.type !== '' && item.version && item.version !== '';
         }).map((item) => {
            return item.type + ':' + item.version
         });
         if (versionValue.length) {
            resValue['version'] = versionValue;
         }

         const param = {
            tag: this.dataSource.tag,
            key: this.dataSource.resKey,
            value: JSON.stringify(resValue)
         };

         this.$http({
            url: this.$util.domain + "/adminapi/v1/tools/addOrUpdateConfig",
            method: "POST",
            dataType: "json",
            body: JSON.stringify(param)
         }).then((res) => {
            if (res.data.error === 10000) {
               this.dialogVisible = false;
               this.$emit('refresh');
            } else {
               this.$util.errorMsg(res.message);
            }
         }).catch((error) => {
            this.$util.errorMsg('获取详情信息失败');
         }).finally(() => {
            this.loading = false;
         });
      },

      // 点击编辑
      clickEdit() {
         // 先重置所有列表，避免缓存问题
         this.switchList = [{ type: '', switch: false }];
         this.deviceList = [{ type: '' }];
         this.versionList = [{ type: '', version: '' }];
         
         // 如果有数据，再填充对应的列表
         if (this.dataSource.resValue && this.dataSource.resValue !== '') {
            try {
               const resValue = JSON.parse(this.dataSource.resValue);
               if (resValue.all && Array.isArray(resValue.all)) {
                  this.switchList = resValue.all.map((item) => {
                     const tmpArr = item.split(':');
                     return {
                        type: tmpArr[0] || '',
                        switch: tmpArr[1] === '1'
                     }
                  });
               }
               if (resValue.device && Array.isArray(resValue.device)) {
                  this.deviceList = resValue.device.map((item) => {
                     return {
                        type: item
                     }
                  });
               }
               if (resValue.version && Array.isArray(resValue.version)) {
                  this.versionList = resValue.version.map((item) => {
                     const tmpArr = item.split(':');
                     return {
                        type: tmpArr[0] || '',
                        version: tmpArr[1] || ''
                     }
                  });
               }
            } catch (error) {
               console.log('序言泽广告-解析数据失败:', error);
               // 解析失败时保持重置后的空状态
            }
         }
         this.dialogVisible = true;
      },

      // 点击添加开关
      clickAddSwitch() {
         if (this.switchList.length >= 3) {
            return;
         }
         this.switchList.push({ type: '', switch: false });
      },

      // 点击删除开关
      clickDeleteSwitch(index) {
         this.switchList.splice(index, 1);
      },

      // 点击添加型号
      clickAddType() {
         this.deviceList.push({ type: '' });
      },

      // 点击删除型号
      clickDeleteType(index) {
         this.deviceList.splice(index, 1);
      },

      // 点击添加版本号
      clickAddVersion() {
         this.versionList.push({ type: '', version: '' });
      },

      // 点击删除版本号
      clickDeleteVersion(index) {
         this.versionList.splice(index, 1);
      },

      // 点击编辑弹框确认
      clickEditDone() {
         this.sendUpdate();
      },

   }
}
</script>

<style scoped>
.item-title {
   font-size: 16px;
   font-weight: 500;
   margin-bottom: 10px;
}

.el-select {
   width: 200px;
}

.el-input {
   width: 200px;
}
</style>


// WEBPACK FOOTER //
// InfoFlowAdShield.vue?437b9ed2